import FavoritesItemProvider, {
    FavoritesItemPropsType as FavoritesItemPropsTypeImport,
} from '../src/components/FavoritesItemProvider/FavoritesItemProvider';

export type FavoritesItemPropsType = FavoritesItemPropsTypeImport;
export default FavoritesItemProvider;
